<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    search
                </mat-icon>
                <app-search-marquee #searchMarquee [searchRequestTypeEnum]="searchRequestTypeEnum"
                                    [searchRequestTileComponentTypeName]="searchRequestTileComponentTypeName">
                </app-search-marquee>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                <!--Enter search criteria to locate saved search requests-->
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <br />
                <table *ngIf="searchResult && searchResult.length > 0" mat-table [dataSource]="searchResultDatasource" class="search-result mat-elevation-z8" matSort>
                    <ng-container matColumnDef="Avatar">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let textMessage" (click)="editItem(textMessage.TextMessageId)">
                            <mat-icon class="material-symbols-outlined">
                                search
                            </mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="FromNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
                        <td mat-cell *matCellDef="let textMessage" (click)="editItem(textMessage.TextMessageId)">
                            {{ textMessage.FromNumber }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ToNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
                        <td mat-cell *matCellDef="let textMessage" (click)="editItem(textMessage.TextMessageId)">
                            {{ textMessage.ToNumber }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="SentOnUTC">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sent On (UTC)</th>
                        <td mat-cell *matCellDef="let textMessage" (click)="editItem(textMessage.TextMessageId)">
                            {{ textMessage.SentOnUTC }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="CreatedOnUTC">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created On (UTC)</th>
                        <td mat-cell *matCellDef="let textMessage" (click)="editItem(textMessage.TextMessageId)">
                            {{ textMessage.CreatedOnUTC }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Delete">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let searchRequest">
                            <button mat-button (click)="deleteItem(searchRequest.SearchRequestId, searchRequest.Name)">
                                <mat-icon class="material-symbols-outlined">
                                    delete_forever
                                </mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>


